import type { BacktestPnlGroupBy } from "../bots/backtest-queries.js";

export const backtestPnlGroups: readonly BacktestPnlGroupBy[] = ["date", "week", "month", "symbol"];

export function backtestPnlGroup(value: string | null): BacktestPnlGroupBy {
  return backtestPnlGroups.includes(value as BacktestPnlGroupBy)
    ? (value as BacktestPnlGroupBy)
    : "date";
}

function isoDate(value: Date): string {
  return value.toISOString().slice(0, 10);
}

export function pnlPeriodRange(
  groupBy: Exclude<BacktestPnlGroupBy, "symbol">,
  key: string,
): { readonly pnlFrom: string; readonly pnlTo: string } {
  if (groupBy === "date") return { pnlFrom: key, pnlTo: key };
  const from = new Date(`${groupBy === "month" ? `${key}-01` : key}T12:00:00.000Z`);
  const to = new Date(from);
  if (groupBy === "week") to.setUTCDate(to.getUTCDate() + 6);
  else to.setUTCMonth(to.getUTCMonth() + 1, 0);
  return { pnlFrom: isoDate(from), pnlTo: isoDate(to) };
}

export function pnlPeriodLabel(groupBy: BacktestPnlGroupBy, key: string): string {
  if (groupBy === "symbol") return key;
  const date = new Date(`${groupBy === "month" ? `${key}-01` : key}T12:00:00.000Z`);
  if (!Number.isFinite(date.valueOf())) return key;
  const value = new Intl.DateTimeFormat(undefined, {
    ...(groupBy === "month" ? {} : { day: "numeric" as const }),
    month: "short",
    year: "numeric",
    timeZone: "UTC",
  }).format(date);
  return groupBy === "week" ? `Week of ${value}` : value;
}
